// native
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// service
import { ApiService } from './api.service';

// constants
import { API_BAA_AGREEMENT_PATH } from '../../constants';

/**
 * Version of the BAA text this frontend presents. Sent with every sign request and validated by
 * the backend, so an acceptance can never be recorded against agreement text the user did not
 * see (e.g. a tab loaded before a deployment). Must match CURRENT_BAA_AGREEMENT_VERSION on the
 * backend; bump both together whenever the agreement text changes materially.
 */
export const BAA_AGREEMENT_VERSION = 2;

@Injectable({
  providedIn: 'root'
})
export class BaaAgreementService {
  constructor(public apiService: ApiService) { }

  public sign(): Observable<any> {
    return this.apiService.post(API_BAA_AGREEMENT_PATH, { version: BAA_AGREEMENT_VERSION }).pipe(map(res => res as any));
  }
}
